$(function(){
	//formタグにクラス追加
	$(".wpcf7-form").addClass("hide_error_message");

	//送信または確認ボタンをクリックしたとき
	$(".wpcf7-confirm, .wpcf7-submit").click(function(){
		//formからクラスを削除
		$(".wpcf7-form").removeClass("hide_error_message");
	});
});
